import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import cn from 'classnames';
import React from 'react';

import type { Chip as Props } from './chip.types';

const Chip: React.FC<Props> = ({ label, onClick, selected }) => (
  <button
    aria-pressed={selected}
    className={cn('chip', { ['chip--selected']: selected })}
    onClick={onClick}
    type="button"
  >
    <Text elementName="span" size={Text.sizes.small}>
      {label}
    </Text>
  </button>
);

export default Chip;
